export default "\n<h1>OOPS!!</h1>\n<h2>404 Page Not Found</h2>\n<p>We couldn't find that page!</p>\n";